<template>
  <nav class="filters">
    <ul class="nav-links main-filters">
      <li class="link">
        <!-- dirty trick to make the button active when the url is '/products/all' as well -->
        <router-link to="/"
        :active-class="($route.path === '/' || $route.path.startsWith('/products/all')) ?
        'router-link-active': ''">
          <div class="navigateTo">All Products</div>
        </router-link>
      </li>
      <li class="link">
       <router-link to="/products/foil_kits">
         <div class="navigateTo">Foil Kits</div>
       </router-link>
      </li>
      <li class="link">
       <router-link to="/products/boards">
         <div class="navigateTo">Boards</div>
       </router-link>
      </li>
      <li class="link">
       <router-link to="/products/wings">
         <div class="navigateTo">Wings</div>
       </router-link>
      </li>
      <li class="link">
       <router-link to="/products/stabs">
         <div class="navigateTo">Stabs</div>
       </router-link>
      </li>
      <li class="link">
       <router-link to="/products/fuselages">
         <div class="navigateTo">Fuselages</div>
       </router-link>
      </li>
      <li class="link">
       <router-link to="/products/masts">
         <div class="navigateTo">Masts</div>
       </router-link>
      </li>
      <li class="link">
       <router-link to="/products/deals">
         <div class="navigateTo deals-link">
           <svg class='deals-icon' width="20" height="20" fill="none" viewBox="0 0 24 24">
             <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
             stroke-width="2" d="M17.25 6.75L6.75 17.25"></path>
             <circle cx="16" cy="16" r="1.5" stroke="currentColor" stroke-linecap="round"
             stroke-linejoin="round" stroke-width="2"></circle>
             <circle cx="8" cy="8" r="1.5" stroke="currentColor" stroke-linecap="round"
             stroke-linejoin="round" stroke-width="2"></circle>
           </svg>
           Deals
         </div>
       </router-link>
      </li>
    </ul>
    <div class='filter-wrapper'>
      <ul class="nav-links secondary-filters">
        <li class="link">
          <!-- Trick to make sure that the active class is present in the right cases -->
          <router-link
          active-class=""
          :class="$route.path.includes('discipline') ? '' : 'router-link-active'"
          :to="'/products/'+($route.params.category || 'all')">
           <div class="navigateTo">All Disciplines</div>
          </router-link>
        </li>
        <!-- List all disciplines in a v-for -->
        <li v-for="(discipline, index) in getDisciplines()"
        :key="index" class="link">
          <router-link :to="'/products/' + ($route.params.category || 'all')
           + '/discipline/'+discipline.key">
            <div class="navigateTo">
              {{ discipline.text }}
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  methods: {
    hasProduct() {
      return this.getProductsInCart.length > 0;
    },
    showPopupCart() {
      this.showOrHiddenPopupCart();
    },
  },
  computed: {
    ...mapGetters([
      'getDisciplines',
    ]),
  },
};
</script>

<style scoped>

  .filters {
    max-width: 1080px;
    margin: 1.75em auto 1.125em;
    display: flex;
    flex-direction: column;
    gap: 1em;
  }

  ul.nav-links {
    margin: 0 1em;
    padding-inline-start: 0;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    align-items: center;
    padding: 0.6em 0;
    list-style: none;
    gap: 0.6em 1.2em;
  }

  ul.nav-links.secondary-filters {
    margin: 0 auto;
    background-color: rgba(255,255,255, .12);
    border-radius: 1em;
    padding: 0.6em 8px;
  }

  .filter-wrapper {
    margin: 0 1em;
  }

  /* ul li.link {
    margin: 0.3em 0.6em;
  } */

  .filters .link a {
    text-decoration: none;
  }

  @media screen and (max-width: 1024px) {
    ul.nav-links{
      max-width: 800px;
      margin: 0 auto;
    }
    ul li.link {
      width: 20%;
      padding: 0.1em 0;
      text-align: center;
    }
    .filters {
      margin: 1.5em auto 0.75em;
    }
  }

  @media screen and (max-width: 680px) {
    ul li.link {
      width: 100%;
      max-width: 150px;
      padding: 0.1em 0;
      text-align: center;
    }
    ul.secondary-filters li.link{
      width: 100%;
      max-width: 145px;
    }
  }

  .navigateTo{
    padding: 5px 16px;
    border: 2px solid transparent;
    border-radius: 30px;
    transition: all 0.3s;
  }

  .navigateTo.deals-link {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 0.25em;
    padding: 4px 16px;
  }

  .deals-icon {
    font-weight: bold;
  }

  .router-link-active .navigateTo{
    background-color: rgba(0, 0, 0, .2);
    border: 2px solid #FA5E42;
    color: #FA5E42;
  }

  a:not(.router-link-active) .navigateTo:hover{
    border: 2px solid #2d3142;
  }

  .secondary-filters .router-link-active .navigateTo{
    background-color: #4F5D75;
    border: 2px solid transparent;
    border: 2px solid #fff;
    color: #fff;
  }

  .secondary-filters a:not(.router-link-active) .navigateTo:hover{
    border: 2px solid rgba(0,0,0, .3);
    border: 2px solid #4F5D75;
    border: 2px solid transparent;
    background-color: #4F5D75;
  }

  .filter-description {
    margin: 0.3em 0.6em;
    padding: 5px 8px;
    border: 2px solid transparent;
    color: rgba(0, 0, 0, 0.75);
    text-transform: uppercase;
  }

</style>



// WEBPACK FOOTER //
// src/components/Filters.vue